export const register = {
    title: ' Регистрация',
    passwordLabel: 'Пароль',
    confirmPassword: 'Подтвердите пароль',
    buttonRegister: 'Зарегистрироваться',
    confirmPasswordLabel: 'Подтвердите пароль',
    policy1: 'Я согласен с',
    policy2: 'Условия и положения',
    and: 'и',
    policy3: 'Политика конфиденциальности.',
    backToLogin: 'Вернуться к входу',
    contentAfterRegister:
        'Поздравляем, вы успешно зарегистрировались! Пожалуйста, проверьте свою электронную почту для подтверждения вашей учетной записи. Если вы не видите письма с подтверждением во входящих письмах, проверьте папку со спамом.',
};
